import React, { Component } from 'react'
import { Link, browserHistory } from "react-router-dom"
import {
  Collapse,
  Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink,
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
  Input, InputGroup, InputGroupAddon, Button,
  Modal, ModalHeader, ModalBody
} from 'reactstrap'
import './navbar.css'
import Contacto from '../contacto'
import Ingreso from '../login'
import Login from '../utilitarios/login'
import { Icon } from 'react-icons-kit'
import { user } from 'react-icons-kit/fa/user'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { whatsapp } from 'react-icons-kit/fa/whatsapp'
import { phoneSquare } from 'react-icons-kit/fa/phoneSquare'
import firebase from 'firebase/app'
import Usuario from '../utilitarios/usuario'
import { detectNavigator } from '../utilitarios/detectNavigator'
import ProductoCategoria from '../utilitarios/productoCategoria'
import WhatsAppButton from '../whatsappButton'
import ReactPixel from 'react-facebook-pixel'
import Logo2021 from '../images/logo2021.png'

const login = new Login()
const usuario = new Usuario()
const productoCategoria = new ProductoCategoria()

export class Navegacion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      user: null,
      isOpen: false,
      modalContact: false,
      modalLogin: false,
      onLogin: true,
      itemAdmin: null,
      categorias: [],
      misPuntos: null,
      navbarClass: 'scrolled'
    }
    this.toggle = this.toggle.bind(this)
    this.toggleModalContacto = this.toggleModalContacto.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onChangeSearch = this.onChangeSearch.bind(this)
    this.btnBuscar = this.btnBuscar.bind(this)
    this.loginSuccess = this.loginSuccess.bind(this)
    this.logOut = this.logOut.bind(this)
    this.toggleModalLogin = this.toggleModalLogin.bind(this)
    this.LinkClick = this.LinkClick.bind(this)
    this.checkScroll = this.checkScroll.bind(this)
  }

  onChangeSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
  }

  onSearch(e) {
    e.preventDefault()
    if (this.state.search != '') {
      ReactPixel.fbq('track', 'Search')
      this.props.history.push(`/productos/search/${this.state.search}`)
    }
  }

  LinkClick() {
    this.state.isOpen && this.toggle()
  }

  toggleModalContacto() {
    this.state.isOpen && this.toggle()
    this.setState(prevState => ({
      modalContact: !prevState.modalContact
    }))
  }

  toggleModalLogin() {
    this.state.isOpen && this.toggle()
    this.setState({
      modalLogin: !this.state.modalLogin
    })
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }


  onUserLogged() {
    if (this.state.user) {
      return (
        <UncontrolledDropdown nav inNavbar>
          <DropdownToggle className="userDropDown" nav caret>
            <Icon size={20} icon={user} />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-principal" right>
            <DropdownItem className="dropdown-item-principal">
              <Link className="nav-link DropdownItem-link" to={`/usuario/${this.state.user && this.state.user.uid}`}>{this.state.user.email}</Link>
            </DropdownItem>
            {
              this.state.itemAdmin
            }
            <DropdownItem className="dropdown-divider-principal" divider />
            <DropdownItem onClick={this.logOut} className="dropdown-item-principal">
              <Link className="nav-link DropdownItem-link" to="/">Salir</Link>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      )
    } else {
      return (
        <NavItem>
          <NavLink className="nav-link-principal" href="#" onClick={this.toggleModalLogin}>Ingresar</NavLink>
        </NavItem>
      )
    }
  }


  btnBuscar() {
    return (
      <InputGroup className="btnBuscar" >
        <Input value={this.state.search} onChange={this.onChangeSearch} placeholder="Buscar..." required={true} />
        <InputGroupAddon addonType="append">
          <Button className="btn-buscar" onClick={this.onSearch}>
            <Icon size={15} icon={ic_search} />
          </Button>
        </InputGroupAddon>
      </InputGroup>
    )
  }

  loginSuccess(user) {
    this.setState({
      user,
      modalLogin: false
    })
  }


  logOut(e) {
    const _this = this
    _this.LinkClick()
    login.logOut().then(result => {
      _this.setState({
        user: null,
        itemAdmin: null,
        misPuntos: null
      })
    })
  }

  leerPuntos(user) {
    const _this = this
    if (!user) return
    usuario.leerUsuario(user.uid).then(usuario => {
      _this.setState({
        misPuntos: usuario.Puntos
      })
    })
  }

  comprobarAdmin(user) {
    usuario.isUserAdmin(user).then(result => {
      if (result) {
        this.setState({
          itemAdmin:
            <DropdownItem className="dropdown-item-principal">
              <Link onClick={this.LinkClick} className="nav-link DropdownItem-link" to="/admin" >Administracion</Link>
            </DropdownItem>
        })
      }
    })
  }

  checkScroll() {
    console.log(window.location.pathname)
    const collapsable = window.matchMedia("screen and (max-width:768px)").matches;
    const mobile = detectNavigator()
    //console.log('mobile', mobile)
    //console.log('collapsable', collapsable)
    document.body.style.marginTop = "0px";
    if (!mobile) {
      //console.log('verify scrolled')
      if (!collapsable) {
        
        if (window.location.pathname === "/")
          if (window.scrollY > 150) {
            this.setState({ navbarClass: "scrolled" })
          } else {
            this.setState({ navbarClass: "" })
          }
        else {
          this.setState({ navbarClass: "scrolled" })
        }
      } else {
        if (window.location.pathname === "/"){
          this.setState({ navbarClass: "scrolled" })
          document.body.style.marginTop = "80px"
        }
      }

    } else { // is mobile
      if (window.location.pathname === "/"){
        this.setState({ navbarClass: "scrolled" })
        document.body.style.marginTop = "80px"
      }
    }

  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.checkScroll)
    this.unlisten()
  }

  componentDidMount() {
    const _this = this
    firebase.auth().onAuthStateChanged(function (user) {
      _this.setState({ user })
      _this.comprobarAdmin(user)
      _this.leerPuntos(user)
    })
    productoCategoria.getCategorias().then(categorias => _this.setState({ categorias }))
    window.addEventListener("scroll", this.checkScroll)
    this.unlisten = this.props.history.listen(this.checkScroll)
    this.checkScroll()
  }


  render() {
    return (
      <div>
        <WhatsAppButton />
        <Navbar className={`navbar fixed-top ${this.state.navbarClass}`} expand="md">
          <Link onClick={this.LinkClick} className="navbar-brand" to="/">
            <img src={Logo2021} className="d-inline-block align-center Logo2021" alt="Eléctrica Caporale" />
          </Link>
          {/*
          <div className="contactoNavbar navbar-brand" >

             <a className="contactoNavbarIcon" href={`tel:+59847245763`}>
              <Icon size={25} icon={phoneSquare} /> 47245763
            </a> 
          </div>
          */}
          <NavbarToggler className="navbar-dark navbarToggle" onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar className="justify-content-end">
            <Nav navbar className="navbar-nav-principal ">
              <NavItem>
                <Link onClick={this.LinkClick} className="nav-link-principal nav-link" to="/">Inicio</Link>
              </NavItem>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle className="nav-link-principal" nav caret>
                  Productos
                </DropdownToggle>
                <DropdownMenu className="MenuCategorias">
                  <Link onClick={this.LinkClick} className="ItemCategoria" to="/productos">
                    <DropdownItem className="ItemCategoria">
                      Todos
                  </DropdownItem>
                  </Link>
                  {
                    this.state.categorias.map(categoria => {
                      return <Link key={categoria.id} onClick={this.LinkClick} className="ItemCategoria" to={`/productos/${categoria.data().Descripcion}`}>
                        <DropdownItem className="ItemCategoria">
                          {categoria.data().Descripcion}
                        </DropdownItem>

                      </Link>
                    })
                  }
                </DropdownMenu>

              </UncontrolledDropdown>
              <NavItem>
                <Link onClick={this.LinkClick} className="nav-link-principal nav-link" to="/empresa">Empresa</Link>
              </NavItem>
              <NavItem>
                <Link onClick={this.LinkClick} className="nav-link-principal nav-link" to="/descargas">Descargas</Link>
              </NavItem>
              <NavItem>
                <NavLink className="nav-link-principal" onClick={this.toggleModalContacto} href="#">Contacto</NavLink>
              </NavItem>
              <NavItem className="NavItemBuscar">
                {!this.state.isOpen && this.btnBuscar()}
              </NavItem>
            </Nav>
            <Nav className="navBuscar" navbar>
              {
                this.onUserLogged()
              }
            </Nav>
          </Collapse>
        </Navbar>

        {
          this.state.misPuntos &&
          <div className="MisPuntos">
            <Link to={`/usuario/${this.state.user && this.state.user.uid}`}>
              Mis puntos: {this.state.misPuntos}
            </Link>
          </div>
        }

        <Modal isOpen={this.state.modalContact} toggle={this.toggleModalContacto} className="ModalContacto">
          <ModalHeader toggle={this.toggleModalContacto} className="font-weight-bold">Contáctanos</ModalHeader>
          <ModalBody>
            <Contacto />
          </ModalBody>
        </Modal>

        <Modal
          toggle={this.toggleModalLogin}
          isOpen={this.state.modalLogin}
        >
          <ModalHeader toggle={this.toggleModalLogin}>Iniciar sesión</ModalHeader>
          <ModalBody>
            <Ingreso loginSuccess={this.loginSuccess} />
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default Navegacion